import {BreadcrumbError} from './BreadcrumbError.js'

export class GetBreadcrumbsError extends BreadcrumbError {}
